<template>
  <BaseNavItem
    :title="$t('organizations')"
    :icon="$vuetify.icons.values.organization"
    :route="{ name: 'organizations', params: $route.params }"
    :visible="visible"
  />
</template>

<script>
import { mapState } from 'vuex'
import { NAMESPACE as APP_NAMESPACE } from '@argon/app/store'
import { NAMESPACE as ORG_NAMESPACE } from '../store'
import { BaseNavItem } from '@argon/app/components'

export default {
  components: { BaseNavItem },
  computed: {
    ...mapState(APP_NAMESPACE, ['isMultiOrg']),
    visible() {
      return this.isMultiOrg
    }
  }
}
</script>

<i18n>
{
  "en": {
    "organizations": "@:labels.organizations"
  },
  "fr": {
    "organizations": "@:labels.organizations"
  }
}
</i18n>
